module.exports = __webpack_public_path__ + "img/1.e165b324.jpg";